import Config from '../config/config';
import { fetch } from './Api'
const config = Config;

export const getS3SignedUrl = ((url) => {
    if (!url) return ''
    if (url === undefined) return ''
    const params = {
        file_url: decodeURIComponent(url)
    };
    return fetch(config.API_URL + '/dataconductorauth/get_presigned_url/', params, 'POST', true, {})
})